export const KEYBOARD_KEYS = {
  ENTER: 'Enter',
  BACKSPACE: 'Backspace',
  DELETE: 'Delete',
  COMMA: ',',
  SEMICOLON: ';',
  SPACE: ' ',
  NEWLINE: '\n',
  ARROW_LEFT: 'ArrowLeft',
} as const;

export const EMAIL_ADDITION_KEYS = [KEYBOARD_KEYS.ENTER, KEYBOARD_KEYS.COMMA, KEYBOARD_KEYS.SEMICOLON];

export const COMPLETION_INDICATORS = [
  KEYBOARD_KEYS.SPACE,
  KEYBOARD_KEYS.COMMA,
  KEYBOARD_KEYS.SEMICOLON,
  KEYBOARD_KEYS.NEWLINE,
];

type EmailAdditionKey = (typeof EMAIL_ADDITION_KEYS)[number];
type CompletionIndicator = (typeof COMPLETION_INDICATORS)[number];

export const isEmailAdditionKey = (key: string): key is EmailAdditionKey =>
  EMAIL_ADDITION_KEYS.includes(key as EmailAdditionKey);

export const isCompletionIndicator = (char: string): char is CompletionIndicator =>
  COMPLETION_INDICATORS.includes(char as CompletionIndicator);
